// Components
export { TrackingMap } from './components/TrackingMap';
export { TrackingInfo } from './components/TrackingInfo';

// Hooks
export { useTrackingSession } from './hooks/useTrackingSession';

// Types
export type { TrackingMapProps } from './components/TrackingMap';
export type { TrackingInfoProps } from './components/TrackingInfo';
export type { UseTrackingSessionResult } from './hooks/useTrackingSession';

// Re-export types from dependencies for convenience
export type { 
  TrackingSessionState, 
  TrackingSessionConfig,
  SSEEventMap 
} from '@trackthatride/realtime';

export type {
  Ride,
  Driver,
  Company,
  ApiResponse
} from '@trackthatride/core';

// Version
export const VERSION = '0.1.0';

// CSS import instruction (for documentation)
export const REQUIRED_CSS = 'maplibre-gl/dist/maplibre-gl.css';